export const GED_TYPE = {
    ELEMENT: 7,
    CONTRIBUTION: 6,
    PENDING_DOCUMENT: 16,
    WORKSHEET: 30,
    OVERLAY: 66,
    UNKNOWN: -1,
} as const;

export type GedType = typeof GED_TYPE[keyof typeof GED_TYPE];

const FILE_ITEM_TYPES: ReadonlySet<number> = new Set([
    GED_TYPE.CONTRIBUTION,
    GED_TYPE.PENDING_DOCUMENT,
    GED_TYPE.WORKSHEET,
    GED_TYPE.OVERLAY,
]);

export const isFileItemType = (type: number): boolean => FILE_ITEM_TYPES.has(type);
